<template>
    <section class="top-instructors-section">
				<div class="custom-container">
					<div class="row align-items-center">
						<div class="col-md-12 col-lg-2">
							<div class="slider-section-header">
								<h2>TOP COACH</h2>
								<!-- <p>We are proud of our international and multi-cultural ethos, and the way our community collaborates to make a difference.</p> -->
								<!-- <router-link to="/instructors" class="btn btn-fill">View All</router-link> -->
							</div>
						</div>
						<div class="col-md-12 col-lg-10">
                            <!-- <div class="row form-row">
                                <div class="col-12 col-md-12">
                                    <div class="form-group">
                                        <div class="change-avatar">
                                            <div class="profile-img">
                                                <img src="@/assets/img/instructors/team3.jpg" alt="User Image">
                                            </div> -->

                            <slick class="sslider top-instructors-slider" :options="slickOptions">
                                <div class="widget-profile pro-widget-content"  v-for="item in topinstructors" :key="item.id">
                                    <div class="profile-info-widget">
                                        <a href="#" class="booking-doc-img">
                                            <img :src="loadImg(item.image)" alt="User Image">
                                        </a>
                                        <div class="profile-det-info">
                                            <h3>{{item.name}}</h3>
                                        </div>
                                    </div>
                                </div>
                                
							</slick>
						</div>
					</div>
				</div>
			</section>
</template>


<script>
import topinstructors from '../../../assets/json/topinstructors'
const images = require.context('@/assets/img/instructors', false, /\.png$|\.jpg$/)

export default {
    data() {
        return {
            topinstructors: topinstructors,
             slickOptions: {
                dots: false,
                autoplay:false,
                infinite: true,
                variableWidth: false,
                slidesToShow: 4,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            }
        }
    },
    methods: {
	    loadImg(imgPath) {
            return images('./' + imgPath)        
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Home/TopInstructors/index.vue